import { Box, Typography } from "@mui/material";
import CheckBoxSvg from "@/assets/svg/CheckBoxSvg";
import { styles } from "./stylesMarketComponents";

interface MarketItemProps {
  icon: React.ReactNode;
  name: string;
  exchanges: string;
  checked: boolean;
  onToggle: () => void;
}

const MarketItem: React.FC<MarketItemProps> = ({ icon, name, exchanges, checked, onToggle }) => (
  <Box onClick={onToggle} sx={styles.marketItem}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={styles.marketItemIcon}>{icon}</Box>
      <Box sx={styles.marketItemContent}>
        <Typography sx={styles.marketItemName}>{name}</Typography>
        <Typography sx={styles.marketItemExchanges}>{exchanges}</Typography>
      </Box>
    </Box>
    <Box sx={styles.checkboxBox(checked)}>{checked && <CheckBoxSvg />}</Box>
  </Box>
);

export default MarketItem;
